import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';

import { DialogLevel } from '../../enums/dialog-level.enum';
import { DialogSize } from '../../enums/dialog-size.enum';

export interface InfoDialogData {
	body: SafeHtml;
	title: string;

	level?: DialogLevel;
	size?: DialogSize;
	submitButton?: string;
}

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-info-dialog',
	styleUrls: ['./info-dialog.component.scss'],
	templateUrl: './info-dialog.component.html',
	standalone: false,
})
export class InfoDialogComponent {
	inputArgs = inject<InfoDialogData>(MAT_DIALOG_DATA);
	private matDialogRef = inject<MatDialogRef<InfoDialogComponent>>(MatDialogRef);

	DIALOG_LEVEL = DialogLevel;
	DIALOG_SIZE = DialogSize;

	closeDialog(): void {
		this.matDialogRef.close();
	}
}
